import { Box, Text, OrderedList, ListItem } from "@chakra-ui/react";
import background from "../assets/bg.jpg";
import Menubar from "../components/Menubar";
import { ACCENT_1_COLOR } from "../constants/color";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";

export default function Curriculum() {
  const {t} = useTranslation();
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "Course",
    "name": "Kurikulum Pelatihan Mugai Ryu Indonesia",
    "description": "Program pelatihan terstruktur meliputi Kata (jurus dasar), Kumitachi (aplikasi berpasangan), dan Tameshigiri (teknik memotong target asli).",
    "provider": {
      "@type": "Organization",
      "name": "Mugai Ryu Indonesia"
    }
  };

  return (
    <Box
      display={"flex"}
      width={"100vw"}
      background={`transparent url(${background})`}
      bgRepeat={"repeat"}
      pb={"24px"}
    >
      <Helmet>
        <title>{t("curriculumTitle")}</title>
        <meta name="description" content={t("curriculumDesc")} />
        <link rel="canonical" href="https://mugairyu-indonesia.com/curriculum" />
        
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
      </Helmet>
      <Box
        width={"100vw"}
        height={"auto"}
      >
        <Menubar />
        <Box
          width={"100vw"}
          px={{ base: "5vw", lg: "20vw" }}
          display={"flex"}
          flexDir={"column"}
          textAlign={"left"}
          mt={"18px"}
        >
          <Text textColor={ACCENT_1_COLOR} fontSize={"30px"}>
            {t("curriculum")}
          </Text>
          <Text
            textColor={"#765946"}
            fontStyle={"italic"}
            fontSize={"18px"}
            mb={"24px"}
          >
            {t("curriculumSubtitle")}
          </Text>

          <Text mb={"18px"}>
            <Text as={"b"}>Iaidō 居合道 </Text>{t("curriculumIaidoSubtitle")}
          </Text>
          <Text mb={"18px"}>
            <Text as={"b"}>Kenjutsu/kumitachi 剣術/組太刀 </Text>{t("curriculumKenjutsuSubtitle")}
          </Text>
          <Text mb={"18px"}>
            <Text as={"b"}>Tameshigiri 試し切り </Text>{t("curriculumTameshigiriSubtitle")}
          </Text>

          <Text textColor={ACCENT_1_COLOR} fontSize={"24px"} mb={"24px"}>
            Iaido
          </Text>
          <Text mb={"18px"}>
            {t("curriculumIaidoDesc")}
          </Text>

          <Text fontSize={"18px"} mb={"8px"}>
            Goyou 五用 (Zagi)
          </Text>
          <OrderedList mb={"18px"} ml={"36px"}>
            <ListItem>Shin 真</ListItem>
            <ListItem>Ren 連</ListItem>
            <ListItem>Sa 左</ListItem>
            <ListItem>Yuu 右</ListItem>
            <ListItem>Sha 捨</ListItem>
          </OrderedList>

          <Text fontSize={"18px"} mb={"8px"}>
            Goka 五箇 (Zagi)
          </Text>
          <OrderedList mb={"18px"} ml={"36px"}>
            <ListItem>Suigetsu 水月</ListItem>
            <ListItem>Inchuuyou 陰中陽</ListItem>
            <ListItem>Youchuuin 陽中陰</ListItem>
            <ListItem>Hibiki Gaeshi 響き返し</ListItem>
            <ListItem>Hazumi 破図味</ListItem>
          </OrderedList>

          <Text fontSize={"18px"} mb={"8px"}>
            Goou 五応 (Tachiwaza)
          </Text>
          <OrderedList mb={"18px"} ml={"36px"}>
            <ListItem>Munazukushi 胸尽くし</ListItem>
            <ListItem>Enyou 円要</ListItem>
            <ListItem>Ryouguruma 両車</ListItem>
            <ListItem>Nookuri 野送り</ListItem>
            <ListItem>Gyokkou 玉光</ListItem>
          </OrderedList>

          <Text fontSize={"18px"} mb={"8px"}>
            Hashirigakari 走り懸り
          </Text>
          <OrderedList mb={"18px"} ml={"36px"}>
            <ListItem>Maegoshi 前腰</ListItem>
            <ListItem>Musougaeshi 夢想返し</ListItem>
            <ListItem>Mawarigakari 回り懸かり</ListItem>
            <ListItem>Miginoteki 右の敵</ListItem>
            <ListItem>Shihou 四方</ListItem>
          </OrderedList>

          <Text mb={"18px"}>{t("curriculumExtraDesc")}</Text>

          <Text textColor={ACCENT_1_COLOR} fontSize={"24px"} mb={"24px"}>
          Kenjutsu/Kumitachi
          </Text>
          <Text mb={"18px"}>
            {t("curriculumKenjutsuDesc")}
          </Text>

          <Text mb={"18px"}>
            {t("curriculumKenjutsuDesc2")}
          </Text>

          <Text fontSize={"18px"} mb={"8px"}>
          Mugai-Ryū Kenjutsu 無外流剣術
          </Text>
          <OrderedList mb={"18px"} ml={"36px"}>
            <ListItem>Hokuto 北斗</ListItem>
            <ListItem>Taihaku 太白</ListItem>
            <ListItem>Inazuma 稲妻</ListItem>
            <ListItem>Kasumi 霞</ListItem>
            <ListItem>Ryuusei 流星</ListItem>
            <ListItem>Kiritome 切留</ListItem>
            <ListItem>Tsukitome 突留</ListItem>
            <ListItem>Ukenagashi 受流し</ListItem>
            <ListItem>Kiriage 切上</ListItem>
            <ListItem>Kuraizume 位詰</ListItem>
          </OrderedList>

          <Text textColor={ACCENT_1_COLOR} fontSize={"24px"} mb={"24px"}>
          Tameshigiri
          </Text>
          <Text>
            {t("curriculumTameshigiriDesc")}
          </Text>
        </Box>
      </Box>
    </Box>
  );
}
